"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

import { useAppSelector } from "@/redux/store";
import { SelectLoggedUser } from "@/redux/Auth";
import MyLink from "@/components/shared/myLink/MyLink";
import heroIllustration from "@/public/images/start.png";

const HeroHome = ({ home }: any) => {
  const [showFilter, setshowFilter] = useState(false);
  const loggedUser = useAppSelector(SelectLoggedUser);

  return (
    <div className="w-full flex flex-col md:flex-row items-center justify-between gap-10 md:gap-0 relative z-10">
      {/* Text Content */}
      <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-right">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight text-white drop-shadow-lg">
          منصتك الأولى
          <span className="text-primaryColor"> للنجاح </span>
          في التعليم
        </h1>
        <p className="text-lg md:text-2xl text-[#C7D0E0] mb-8 max-w-xl">
          منصة Eduvalu تهدف إلى تطوير العملية التعليمية ومساعدة الطلاب على تحقيق
          التفوق في جميع المواد من خلال خدمات تعليمية متكاملة وحديثة.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full md:justify-end justify-center">
          {loggedUser.isLoggedIn && loggedUser.userToken ? (
            <>
              <MyLink
                href="/courses"
                className="bg-primaryColor text-white font-semibold py-3 px-8 rounded-lg shadow-md bg-opacity-80 transition"
              >
                عرض الكورسات
              </MyLink>
              <MyLink
                href="/fullExams"
                className="bg-[#202225] text-primaryColor font-semibold py-3 px-8 rounded-lg border border-primaryColor shadow-md hover:text-white transition"
              >
                عرض الاختبارات الشاملة
              </MyLink>
              <MyLink
                href="https://book-eduvalu.com"
                className="bg-[#323538] text-white font-semibold py-3 px-8 rounded-lg border border-white shadow-md hover:bg-primaryColor hover:text-white transition"
              >
                شراء كتب
              </MyLink>
            </>
          ) : (
            <>
              <MyLink
                href="/signup"
                className="bg-primaryColor text-white font-semibold py-3 px-8 rounded-lg shadow-md bg-opacity-80 transition"
              >
                أنشئ حسابك الآن
              </MyLink>
              <MyLink
                href="/courses"
                className="bg-[#202225] text-primaryColor font-semibold py-3 px-8 rounded-lg border border-primaryColor shadow-md hover:text-white transition"
              >
                تصفح الكورسات
              </MyLink>
            </>
          )}
        </div>
      </div>
      {/* Illustration */}
      <div className="flex-1 flex items-center justify-center md:justify-end">
        <div className="relative w-[320px] h-[320px] md:w-[400px] md:h-[400px]">
          <Image
            src={heroIllustration}
            alt="منصة التعليم"
            fill
            className="object-contain drop-shadow-2xl rounded-2xl"
            priority
          />
          {/* Decorative background circle */}
          <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] md:w-[450px] md:h-[450px] bg-primaryColor/20 rounded-full blur-2xl" />
        </div>
      </div>
    </div>
  );
};

export default HeroHome;
